export const PODCAST_FEATURED_PLAY = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.PodcastFeaturedPlayWidgetElement';
